import { render } from "./create.vue?vue&type=template&id=49dca072&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import "./create.vue?vue&type=style&index=0&id=49dca072&scoped=true&lang=css"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49dca072"]])

export default __exports__